module.exports = __webpack_public_path__ + "static/media/featureIcon1.1e4bd2ec.png";